import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"

import Modal from "@irati/ui/src/Modal"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import CreatePoll from "@irati/recognition/apollo/mutation/Poll/Create"
import tracking from "@irati-tracking/recognition/poll"
import {EVERYONE, SPECIFIC_TEAMS} from "@irati/recognition/constants/share"

import Create from "./Create"
import Inspire from "./Inspire"
import {CancelConfirm, DatePicker} from "../shared"
import TitleInlineModal from "../shared/layouts/TitleInlineModal"

export const CREATE = "CREATE"
export const INSPIRE = "INSPIRE"
export const TROPHY = "TROPHY"
export const DATE_PICKER = "DATE_PICKER"
export const CANCEL_CONFIRM = "CANCEL_CONFIRM"

const modals = [CREATE, TROPHY, INSPIRE, DATE_PICKER, CANCEL_CONFIRM]

const EMPTY_POLL = {
  companyValues: [],
  teams: []
}

class CreatePollPopup extends Component {
  static propTypes = {
    onExited: PropTypes.func,
    focusReward: PropTypes.bool
  }

  static defaultProps = {
    onExited: () => { },
    focusReward: false
  }

  constructor(props) {
    super(props)
    this.state = {
      share: EVERYONE,
      show: modalStory(modals, null)
    }
  }

  // looks for any active popups, if none; we know its a new instance of popup so clear poll
  shouldClearPoll = () => !anyStoriesOpen(this.state.show)

  show = (modalToShow = CREATE) => {
    this.setState(({poll, show}) => ({
      show: modalStory(modals, modalToShow, show),
      poll: this.shouldClearPoll() ? EMPTY_POLL : poll
    }))
  }

  hide = () => {
    this.setState({show: modalStory(modals, null)})
  }

  cancelConfirm = () => {
    const {poll} = this.state
    if (poll === EMPTY_POLL) {
      this.hide()
    } else {
      this.show(CANCEL_CONFIRM)
    }
  }

  handleChange = (poll, key, value) => {
    this.setState({
      poll: {
        ...poll,
        [key]: value
      }
    })
  }

  handleInspire = (inspiration) => {
    this.setState(({poll}) => ({
      poll: {
        ...poll,
        ...inspiration
      }
    }))
    this.show(CREATE)
  }

  handlePollCreationComplete = () => {
    const {poll} = this.state
    tracking.createPoll(poll)
    this.hide()
  }

  handlePollError = (response) => {
    tracking.errorsPoll(response)
  }

  handleAfterExit = () => {
    if (!anyStoriesOpen(this.state.show)) {
      this.props.onExited()
    }
  }

  handleSharingOptionChange = (share) => {
    if (share !== SPECIFIC_TEAMS) {
      this.handleChange(this.state.poll, "teams", [])
    }

    this.setState({
      share
    })
  }

  render() {
    const {show, poll, share} = this.state
    const {focusReward} = this.props
    if (!poll) {
      return null
    }

    return (
      <CreatePoll
        poll={poll}
        onCompleted={this.handlePollCreationComplete}
        onError={this.handlePollError}>
        {(onSubmit, apolloState) => (
          <Fragment>
            <TitleInlineModal
              show={show[CREATE]}
              onHide={this.cancelConfirm}
              onExited={this.handleAfterExit}>
              <Create
                poll={poll}
                share={share}
                onChange={this.handleChange}
                onSubmit={onSubmit}
                onSharingOptionChange={this.handleSharingOptionChange}
                apolloState={apolloState}
                focusReward={focusReward}
                selectScreen={this.show} />
            </TitleInlineModal>
            <TitleInlineModal
              show={show[INSPIRE]}
              onHide={this.cancelConfirm}
              onBack={() => this.show(CREATE)}
              onExited={this.handleAfterExit}>
              <Inspire onSelect={this.handleInspire} selectScreen={this.show} />
            </TitleInlineModal>
            <TitleInlineModal
              show={show[DATE_PICKER]}
              onHide={this.cancelConfirm}
              onBack={() => this.show(CREATE)}
              onExited={this.handleAfterExit}>
              <DatePicker poll={poll} onChange={this.handleChange} onSubmit={() => this.show(CREATE)} />
            </TitleInlineModal>
            <Modal
              show={show[CANCEL_CONFIRM]}
              onExited={this.handleAfterExit}>
              <CancelConfirm previous={show.previous} selectScreen={this.show} onHide={this.hide} />
            </Modal>
          </Fragment>
        )}
      </CreatePoll>
    )
  }
}

export default CreatePollPopup
